import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0eb925ac"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "flex flex_between"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_3 = {
  class: "content_box"
};
var _hoisted_4 = {
  class: "form_item flex flex_between"
};
var _hoisted_5 = {
  class: "left"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "self_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label_title"
  }, "难事类型")], -1);
});

var _hoisted_7 = {
  class: "right"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "self_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label_title"
  }, "上报街道")], -1);
});

var _hoisted_9 = {
  class: "form_item flex flex_between"
};
var _hoisted_10 = {
  class: "left"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "self_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label_title"
  }, "联系人姓名")], -1);
});

var _hoisted_12 = {
  class: "right"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "self_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label_title"
  }, "联系方式")], -1);
});

var _hoisted_14 = {
  class: "form_item flex flex_between"
};
var _hoisted_15 = {
  class: "left"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "self_label"
  }, [/*#__PURE__*/_createElementVNode("label", {
    class: "adorn"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "label_title"
  }, "审批人")], -1);
});

var _hoisted_17 = {
  class: "footer flex flex_justify_center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_input = _resolveComponent("el-input");

  var _component_Process = _resolveComponent("Process");

  var _component_Approve = _resolveComponent("Approve");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createBlock(_component_el_form, {
    ref: "RefForm",
    class: "window",
    model: _ctx.form,
    rules: _ctx.rules
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
        title: "难事上报"
      }), _createElementVNode("div", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.back && _ctx.back.apply(_ctx, arguments);
        })
      }, [_hoisted_2, _createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_ArrowRight, {
            color: "#c62423"
          })];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_form_item, {
        prop: "typeId"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: _ctx.form.typeId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _ctx.form.typeId = $event;
            }),
            placeholder: "请选择类型"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TypeList, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.typeId,
                  label: item.typeName,
                  value: item.typeId
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_form_item, {
        prop: "street"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.street,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.form.street = $event;
            }),
            placeholder: "请填写上报街道"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_form_item, {
        prop: "personName"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.personName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return _ctx.form.personName = $event;
            }),
            placeholder: "请填写联系人姓名"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_form_item, {
        prop: "mobile"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_input, {
            modelValue: _ctx.form.mobile,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return _ctx.form.mobile = $event;
            }),
            placeholder: "请填写联系方式"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_form_item, {
        prop: "approvalId"
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createVNode(_component_el_input, {
            modelValue: _ctx.form.approvalId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return _ctx.form.approvalId = $event;
            })
          }, null, 8, ["modelValue"]), [[_vShow, false]]), _createElementVNode("div", null, [_createElementVNode("span", {
            onClick: _cache[6] || (_cache[6] = //@ts-ignore
            function () {
              return _ctx.getApprovalId && _ctx.getApprovalId.apply(_ctx, arguments);
            }),
            class: "approval_btn"
          }, _toDisplayString(_ctx.form.approvalId ? _ctx.approvalName : '+选择审批人'), 1)])];
        }),
        _: 1
      })])]), _createVNode(_component_Process, {
        ref: "RefProcess",
        title: "问题描述"
      }, null, 512)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: "btn",
        onClick: _cache[7] || (_cache[7] = //@ts-ignore
        function () {
          return _ctx.submit && _ctx.submit.apply(_ctx, arguments);
        })
      }, " 提交 ")]), _createVNode(_component_Approve, {
        ref: "PublishApproveRef",
        onApprovalPepole: _ctx.approvalPepole
      }, null, 8, ["onApprovalPepole"])];
    }),
    _: 1
  }, 8, ["model", "rules"]);
}